import React from 'react';
import { Button } from '@mui/material';
import AssetracIcon from '../AssetracIcon/AssetracIcon';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const FilterChip = ({
  icon,
  materialIcon,
  label,
  active = false,
  onClick,
  'aria-label': ariaLabel,
  ...props
}) => {
  const color = active ? '#FFFFFF' : '#E8DCDA';
  return (
    <Button
      onClick={onClick}
      aria-label={ariaLabel || label}
      sx={{
        backgroundColor: active ? '#302F2E' : 'transparent',
        color,
        borderRadius: '8px',
        height: '32px',
        padding: '6px 8px',
        gap: '8px',
        fontSize: '14px',
        fontWeight: 400,
        textTransform: 'none',
        minWidth: 0,
        flexShrink: 0,
        '&:hover': { backgroundColor: active ? '#302F2E' : 'rgba(232,220,218,0.08)' },
        '& .MuiButton-startIcon': { margin: 0 },
        '& .MuiButton-endIcon': { margin: 0 },
      }}
      startIcon={
        icon ? (
          <AssetracIcon src={icon} size={18} alt="" aria-hidden="true" />
        ) : materialIcon ? (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: 18, lineHeight: 1, color }}
            aria-hidden="true"
          >
            {materialIcon}
          </span>
        ) : null
      }
      endIcon={<ArrowDropDownIcon sx={{ fontSize: 18, color }} />}
      {...props}
    >
      {label}
    </Button>
  );
};

export default FilterChip;
